import React from 'react';
import { useAppSelector } from 'store/hooks';
import SecclSearchStocks from '../components/SecclSearchStocks';
import AlpacaSearchStocks from '../components/AlpacaSearchStocks';
import { selectActiveTradingAccountBroker } from '../reducers/selectors';
import { isWeb } from '../../../constants';
const SearchStocksScreen = () => {
    const broker = useAppSelector(selectActiveTradingAccountBroker);
    // Web only supports Seccl accounts
    if (broker === 'seccl' || !broker || isWeb) {
        return <SecclSearchStocks />;
    }
    return <AlpacaSearchStocks />;
};
export default SearchStocksScreen;
